import { Component, Input } from "@angular/core";

import { IMenuOption, IMenuSelectEventData } from "@tylertech/forge";

import { Command } from "../../interfaces";

@Component({
    selector: "command-menu",
    templateUrl: "./commandMenu.tmpl.html",
    standalone: false
})
export class CommandMenuComponent
{
    @Input("commands")
    private set commands(value: ReadonlyArray<Command>)
    {
        this.menuOptions = value.filter(v => v.isVisible).map(x =>
        {
            return {
                icon: x.icon,
                label: x.label,
                value: x,
            };
        });
    }

    @Input() readonly disabled: boolean;
    @Input() readonly icon: string;
    @Input() readonly dense: boolean;

    menuOptions: ReadonlyArray<IMenuOption>;

    onForgeMenuItemSelect($event: Event): void
    {
        const detail = ($event as CustomEvent<IMenuSelectEventData<Command>>).detail;
        detail.value.action($event);
    }

    menuOpened(e): void
    {
        e.target.activateFirstOption();
    }
}
